export default __webpack_public_path__ + "static/media/1195.edd9ad05.png";